import React, { ReactNode } from 'react';

export type TooltipProps = {
  text: string;
  children: ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => (
  <span className="tooltip-container">
    <span className="">{children}</span>
    <span className="tooltip-bubble" >{text}</span>
  </span>
);

export default Tooltip; 